<template>
    <div class="languages" :class="{ 'active': dropdownIsOpen }" @click.stop="">
        <a v-if="activeLanguage" 
            class="languages__current" 
            href="javascript:;" 
            @click="dropdownIsOpen = !dropdownIsOpen">
                <fa-icon :icon="['fal', 'globe']"></fa-icon>
                {{ activeLanguage.locale }}
            </a>

        <ul class="languages__options">
            <li v-for="language in languages" 
                :key="language.id" 
                :class="{'active': activeLanguage.id == language.id}">
                <span v-if="activeLanguage.id == language.id">{{ language.name }}</span>
                <a
                    v-else-if="$route.meta.alternateLanguages && $route.meta.alternateLanguages[language.locale]"
                    :href="`/${$route.meta.alternateLanguages[language.locale]}`">{{ language.name }}
                </a>
                <a
                    v-else
                    :href="`/${language.locale}`">{{ language.name }}
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
import http from 'axios'
export default {
    data() {
        return {
            dropdownIsOpen: false,
        }
    },

    mounted() {
        document.body.addEventListener('click', () => this.dropdownIsOpen = false);
    },

    computed: {
        languages() {
            return this.$store.state.languages;
        },

        activeLanguage() {
            return this.$store.getters.activeLanguage;
        },
    },
}
</script>



// WEBPACK FOOTER //
// ../default-js/js/components/common/LanguageSwitch.vue